import { createApiInstance } from './index';

const api = createApiInstance();

/**
 * 依 company_uuid 取得公司資料
 * @param {string} companyUuid
 */
export const getCompanyById = (companyUuid) => {
  return api.post('get_company_by_id/', {
    company_uuid: companyUuid,
  });
};

/**
 * 新增帳號（由管理者新增成員）
 * @param {Object} payload
 */
export const createAccountByAddMember = (payload) => {
  return api.post('create_account_by_add_member/', payload);
};

/**
 * 邀請公司成員
 * @param {Object} payload
 * @param {string} payload.company_uuid
 * @param {string[]} payload.members
 */
export const inviteCompanyMember = (payload) => {
  return api.post('invite_company_member/', payload);
};

/**
 * 取得公司群組成員（依 company member uuid）
 * @param {string} memberUuid
 */
export const getCompanyGroupMembersByMemberId = (memberUuid) => {
  return api.post('get_company_group_members_by_member_id/', {
    member_uuid: memberUuid,
  });
};

/**
 * 取得「不在該公司成員底下」的公司群組
 * @param {string} companyUuid
 * @param {string} memberUuid
 */
export const getCompanyGroupNotInMember = (companyUuid, memberUuid) => {
  return api.post('get_company_group_not_in_member/', {
    company_uuid: companyUuid,
    member_uuid: memberUuid,
  });
};

/**
 * 取得群組列表 (依群組 ID)
 * @param {Array<string>} groupUuids
 */
export const getGroupsByIdList = (groupUuids = []) => {
  return api.post('get_groups_by_id_list/', { group_uuids: groupUuids });
};

/**
 * 刪除公司群組成員
 * @param {string} groupMemberUuid
 */
export const deleteCompanyGroupMemberApi = (groupMemberUuid) => {
  return api.post('delete_company_group_member/', { group_member_uuid: groupMemberUuid });
};

/**
 * 新增公司群組成員
 * @param {string} groupUuid
 * @param {string} memberUuid
 */
export const addCompanyGroupMemberApi = (groupUuid, memberUuid) => {
  return api.post('add_company_group_member/', {
    company_group_uuid: groupUuid,
    company_member_uuid: memberUuid,
  });
};

/**
 * 取得公司成員
 * @param {string} companyUuid
 */
export const getCompanyMembersByCompanyId = (companyUuid) => {
  return api.post('get_companymember_by_cid/', { company_uuid: companyUuid });
};

/**
 * 刪除公司成員
 * @param {string} memberUuid
 */
export const deleteCompanyMember = (memberUuid) => {
  return api.post('delete_company_member/', { member_uuid: memberUuid });
};

/**
 * 更新公司資訊
 * @param {Object} payload
 */
export const updateCompany = (payload) => {
  return api.post('update_company/', payload);
};


/**
 * 依 company_id 取得專案
 */
export const getProjectsByCompanyId = (companyUuid) => {
  return api.post('get_projects_by_company_id/', {
    company_uuid: companyUuid,
  });
};

/**
 * 依多個 member uuid 取得公司成員
 */
export const getCompanyMembersByNoList = (memberUuidList) => {
  return api.post('get_company_members_by_no_list/', {
    member_uuid_list: memberUuidList,
  });
};


/**
 * 新增部門
 * @param {Object} payload
 * @param {string} companyUuid
 * @param {string} name
 * @param {string} parentUuid
 */
export const createCompanyGroup = (payload) => {
  return api.post("create_company_group/", payload);
};

/**
 * 編輯部門
 * @param {Object} payload
 * @param {string} groupUuid
 * @param {string} managerUuid
 *  {
 *    name?: string,
 *    status?: number
 *  }
 */
export const EditCompanyGroup = (payload) => {
  return api.post('edit_company_group/', payload);
};

/**
 * 取得該公司中不屬於 group_id 的成員
 * @param {string} companyUuid
 * @param {string} groupUuid
 */
export const getNonCompGroupMemberByGroupNo = (companyUuid, groupUuid) => {
  return api.post('get_non_group_members_by_group_id/', {
    company_uuid: companyUuid,
    group_uuid: groupUuid,
  });
};

/**
 * 依多個 id 取得 部門透過部門編號列表
 */
export const getCompanyGroupsByNoList = (uuidList) => {
  return api.post('get_company_groups_by_no_list/', {
    uuid_list: uuidList,
  });
};


/**
 * 取得公司成員
 * @param {string} compGroupUuid
 */
export const getCompanyGroupMembersByCompanyGroupId = (compGroupUuid) => {
  return api.post('get_company_group_members_by_group_id/', { group_uuid: compGroupUuid });
};

/**
 * 依 company_uuid 取得公司群組
 */
export const getAllCompGroupsByCompNo = (companyUuid) => {
  return api.post('get_company_groups_by_company_id/', {
    company_uuid: companyUuid,
  });
};
